export default "__VITE_ASSET__BFLxOYLf__"